// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__PXnui"};